<template>
  <div class="bm-empty">
    <v-icon size="40" color="grey lighten-1">{{ icon }}</v-icon>
    <div class="subtitle-1 font-weight-medium mt-1">{{ title }}</div>
    <div class="bm-tiny" style="max-width: 520px">{{ text }}</div>
    <slot></slot>
  </div>
</template>

<script>
/** Empty / first-run state: what is missing and one way out. */
export default {
  name: "empty-state",
  props: {
    icon: { type: String, default: "mdi-information-outline" },
    title: { type: String, required: true },
    text: { type: String, default: "" },
  },
};
</script>

<style scoped>
.bm-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 6px;
  padding: 40px 24px;
}
</style>
